import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=ed426bfa"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports